import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { FetchFromBackoffice } from "../../utils/request";
import {
  CollapsibleTable,
  ColumnName,
  DataItem,
} from "../../components/molecules/CollapsableTable";
import { TextTitle } from "../../components/atoms/text/titles";
import { DateTime } from "luxon";
import { Tooltip } from "@material-ui/core";
import { Search } from "@mui/icons-material";
import { NavigateFunction, useNavigate } from "react-router-dom";
import LogLevelDisplay from "../../components/molecules/logs/logLevelDisplay";
import { padding } from "../../theme";

const columnNames: ColumnName[] = [
  {
    displayName: "Message",
    id: "message",
    aggregate: false,
    grouped: true,
    level: 0,
    align: "left",
    altText: (row, agg, level) => {
      if (row.groupBy.length > 50) {
        return <Tooltip title={row.groupBy}><Box>{`${row.groupBy.substring(0, 40)}... `}</Box></Tooltip>
      }
      else {
        return row.groupBy
      }
    },
    visible: true,
  },

  {
    displayName: "Store",
    id: "nodeName",
    aggregate: true,
    grouped: true,
    level: 1,
    align: "left",
    visible: true,
  },
  {
    displayName: "Total",
    id: "timestamp",
    aggregate: false,
    grouped: false,
    level: 2,
    align: "left",
    visible: true,
    formatter: (value: string) =>
      DateTime.fromISO(value).toFormat("HH:mm:ss"),
    altText: (row, agg, level) => {
      let total = 0
      if (level === 0) {
        row.items.forEach(e => {
          total = total + e.items?.length
        });
        return total.toString()
      } else if (level === 1) {
        return row.items.length.toString()
      }
    },
  },
  {
    displayName: "Error/Warning",
    id: "level",
    aggregate: false,
    grouped: false,
    level: 0,
    align: "left",
    visible: true,
    altText: (row) => {
      return <LogLevelDisplay level={capitalize(row.items[0].items[0].level)}/>;
    },
    navigationButton: (data, navigate) => { return <Button variant='outlined' onClick={() => navigationButtonAction(data, navigate)} startIcon={<Search/>}>View logs</Button>}
  },
];

const capitalize = (str) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

const navigationButtonAction = (data: DataItem, navigate: NavigateFunction) => {
  if(data.timestamp && data.serialNo){
    const from = DateTime.fromISO(data.timestamp).plus({"minutes": 1}).toISO()
    const until = DateTime.fromISO(data.timestamp).minus({"minutes": 1}).toISO()
    navigate(`/hubs/${data.serialNo}?tab=2&until=${encodeURIComponent(until)}&from=${encodeURIComponent(from)}`)
  }
}

export const MachineLogTable = ({
  to,
  from,
  warnings,
  noErrorsOrWarnings
}: {
  to: DateTime;
  from: DateTime;
  warnings: boolean,
  noErrorsOrWarnings?: boolean
}) => {
  const [data, setData] = useState<DataItem>([]);
  useEffect(() => {
    if (to && from && !noErrorsOrWarnings) {
      FetchFromBackoffice<[]>(
        `telemetry/error-warning/${from?.toFormat(
          "yyyy-MM-dd"
        )}/and/${to?.toFormat("yyyy-MM-dd")}?filterType=${warnings ? "warning" : "no_warning"}`
      )
        .then((r) => {
          setData(r);
        })
        .catch((e) => console.log("Error: ", e));
    }
  }, [to, from, warnings]);

  return (
    <Box sx={{marginTop:padding/2}}>
      <TextTitle title={"Details: " + from.toFormat("LLL dd")}/>
      {
        !noErrorsOrWarnings ? 
            <CollapsibleTable
            columnNames={columnNames}
            rows={data.length > 0 ? data : []}
          ></CollapsibleTable>
          : <Typography sx= {{padding:padding/2}}>{`No errors${warnings ? ' or warnings' : ''} this day.`}</Typography>
      }
      
    </Box>
  );
};
